/* CA mirror of US store improvements - Oct 2026 */
(function () {
  var SALE_HANDLE = (window.AP_STORE && window.AP_STORE.sale) || 'scrubs-sale-up-to-70-off';
  var SALE = '/collections/' + SALE_HANDLE;
  function ready(f) { if (document.readyState !== 'loading') f(); else document.addEventListener('DOMContentLoaded', f); }

  /* 1. Announcement ticker: speed by length, pause on touch */
  ready(function () {
    var t = document.querySelector('.cam-ticker'); if (!t) return;
    var tr = t.querySelector('.cam-ticker__track');
    if (tr) { var w = tr.scrollWidth / 2; tr.style.setProperty('--cam-dur', Math.max(20, Math.round(w / 45)) + 's'); }
    var timer;
    t.addEventListener('touchstart', function () { clearTimeout(timer); t.classList.add('is-paused'); }, { passive: true });
    t.addEventListener('touchend', function () { timer = setTimeout(function () { t.classList.remove('is-paused'); }, 2500); }, { passive: true });
  });

  /* 2. Region bar: shown to visitors from the other store's country (#474: data-cam-region = that country) */
  ready(function () {
    var b = document.querySelector('[data-cam-region]'); if (!b) return;
    var want = (b.getAttribute('data-cam-region') || 'US').toUpperCase();
    function apply(c) { if (c === want) b.hidden = false; }
    try { var c = sessionStorage.getItem('camCountry'); if (c !== null) { apply(c); return; } } catch (e) {}
    fetch('/browsing_context_suggestions.json').then(function (r) { return r.json(); }).then(function (j) {
      var c = (j && j.detected_values && j.detected_values.country && j.detected_values.country.handle) || '';
      c = String(c).toUpperCase();
      try { sessionStorage.setItem('camCountry', c); } catch (e) {}
      apply(c);
    }).catch(function () {});
  });

  /* 3. Collections: Sort by menu. Sale defaults to Featured (manual order set in admin: fullest size runs first, cheap/expensive alternating); Biggest discount on request */
  /* #472: strip the locale prefix ("/fr/collections/x" -> "/collections/x") so French pages get the Sort menu too. */
  function path() { return location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, ''); }
  function onCollection() { return /^\/collections\/[^\/]+\/?$/.test(path()); }
  function handle() { return path().replace(/\/$/, '').split('/')[2]; }
  function sortParam() { return new URLSearchParams(location.search).get('sort_by') || ''; }
  function refreshColors() {
    if (typeof AP_COLOR_MAP !== 'undefined' && AP_COLOR_MAP.applyAll) AP_COLOR_MAP.applyAll();
    if (typeof initCollectionColorMatch === 'function') initCollectionColorMatch();
  }
  function loadAll(grid) {
    var btn = document.querySelector('[data-load-more]');
    var next = btn ? btn.getAttribute('data-next-url') : null, pages = 1;
    function step() {
      if (!next || pages >= 20) return Promise.resolve();
      return fetch(next).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.querySelector('[data-product-grid]');
        if (ng) while (ng.children.length) grid.appendChild(ng.children[0]);
        var nb = doc.querySelector('[data-load-more]');
        next = nb ? nb.getAttribute('data-next-url') : null; pages++; return step();
      });
    }
    return step().then(function () { var w = document.querySelector('[data-load-more-wrap]'); if (w) w.style.display = 'none'; });
  }
  function pct(card) { var b = card.querySelector('.s-product-card__badge'); var n = b ? parseInt(b.textContent, 10) : 0; return isNaN(n) ? 0 : n; }
  function sortByDiscount(grid) {
    var cards = [].slice.call(grid.children).map(function (c, i) { return { c: c, p: pct(c), i: i }; });
    cards.sort(function (a, b) { return (b.p - a.p) || (a.i - b.i); });
    cards.forEach(function (o) { grid.appendChild(o.c); });
    refreshColors();
  }
  var isSale = onCollection() && handle() === SALE_HANDLE;
  /* Sale + Biggest discount: load every page, deepest discount first */
  if (isSale && sortParam() === 'discount') {
    ready(function () { var g = document.querySelector('[data-product-grid]'); if (!g) return; g.style.opacity = '0'; loadAll(g).then(function () { sortByDiscount(g); }).catch(function () {}).then(function () { g.style.opacity = ''; }); });
  }
  ready(function () {
    if (!onCollection()) return;
    var cnt = document.querySelector('[data-product-count]'); if (!cnt || document.querySelector('.cam-toolbar')) return;
    var cur = sortParam();
    // French storefront gets French labels; the sort values are the same.
    var FR = /^fr/i.test(document.documentElement.lang || '');
    var L = FR
      ? { feat: 'En vedette', disc: 'Plus gros rabais', newest: 'Nouveautés', hi: 'Prix décroissant', lo: 'Prix croissant', best: 'Meilleures ventes', sort: 'Trier par' }
      : { feat: 'Featured', disc: 'Biggest discount', newest: 'Newest', hi: 'Price: High to Low', lo: 'Price: Low to High', best: 'Best Selling', sort: 'Sort by' };
    var opts = isSale ? [['', L.feat], ['discount', L.disc], ['created-descending', L.newest]] : [['', L.feat]];
    opts = opts.concat([['price-descending', L.hi], ['price-ascending', L.lo], ['best-selling', L.best]]);
    if (!isSale) opts.push(['created-descending', L.newest]);
    var bar = document.createElement('div'); bar.className = 'cam-toolbar';
    cnt.parentNode.insertBefore(bar, cnt); bar.appendChild(cnt);
    var lab = document.createElement('label'); lab.className = 'cam-sort'; lab.innerHTML = '<span>' + L.sort + '</span>';
    var sel = document.createElement('select'); sel.setAttribute('aria-label', L.sort);
    opts.forEach(function (o) { var op = document.createElement('option'); op.value = o[0]; op.textContent = o[1]; if (o[0] === cur) op.selected = true; sel.appendChild(op); });
    sel.addEventListener('change', function () {
      var u = new URL(location.href);
      if (sel.value) u.searchParams.set('sort_by', sel.value); else u.searchParams.delete('sort_by');
      u.searchParams.delete('page'); location.href = u.toString();
    });
    lab.appendChild(sel); bar.appendChild(lab);
  });

  /* 4. Cart page + cart drawer: final-sale notice above Checkout, Buy 5 Get 1 promo message */
  function flags() {
    return fetch('/?sections=cam-cart-flags', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var d = document.createElement('div'); d.innerHTML = j['cam-cart-flags'] || '';
      var el = d.querySelector('[data-cam-flags]'); return el ? JSON.parse(el.textContent) : { promo: 0, final: 0, items: 0 };
    });
  }
  var PROMO_ON = false; /* Buy 5 get the 6th free ended Oct 2026; flip to true to bring the cart message back */
  function promoHtml(n) {
    var head = '<b>Buy any 5 sale items, get the 6th FREE</b>';
    if (n >= 6) return '<b>Your 6th sale item is FREE</b>Discount applied automatically at checkout.';
    if (n > 0) { var need = 6 - n; return head + 'You have ' + n + ' sale item' + (n === 1 ? '' : 's') + ' in your cart. Add ' + need + ' more and the 6th is free. <a href="' + SALE + '">Shop the sale</a>'; }
    return head + 'Applied automatically at checkout. <a href="' + SALE + '">Shop the sale</a>';
  }
  var FINAL = 'Sale items are final sale – no returns or exchanges.';
  function box(cls, parent, before) {
    var b = parent.querySelector('.' + cls);
    if (!b) { b = document.createElement('div'); b.className = 'cam-note ' + cls; b.hidden = true; if (before && before.parentNode) before.parentNode.insertBefore(b, before); else parent.appendChild(b); }
    return b;
  }
  function paint(promoBox, finalBox) {
    return flags().then(function (f) {
      if (promoBox) { var h = PROMO_ON && f.items > 0 ? promoHtml(f.promo) : ''; promoBox.hidden = !h; if (promoBox.getAttribute('data-h') !== h) { promoBox.innerHTML = h; promoBox.setAttribute('data-h', h); } }
      if (finalBox) { finalBox.hidden = !(f.final > 0); finalBox.textContent = FINAL; }
    }).catch(function () {});
  }
  function watch(root, fn) {
    var t;
    new MutationObserver(function (ms) {
      if (ms.every(function (m) { var n = m.target.nodeType === 1 ? m.target : m.target.parentNode; return n && n.closest && n.closest('.cam-note'); })) return;
      clearTimeout(t); t = setTimeout(fn, 450);
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }
  ready(function () {
    var sec = document.querySelector('.s-cart');
    if (sec && sec.querySelector('[data-cart-items]')) {
      var run = function () {
        var hdr = sec.querySelector('.s-cart__header');
        var form = sec.querySelector('.s-cart__footer-right form');
        paint(box('cam-note--promo', sec.querySelector('.container') || sec, hdr ? hdr.nextSibling : null),
              form ? box('cam-note--final', form.parentNode, form) : null);
      };
      run(); watch(sec, run);
    }
    var d = document.querySelector('[data-cart-drawer]');
    if (d) {
      var runD = function () {
        var main = d.querySelector('.s-cart-drawer__main') || d;
        paint(box('cam-note--promo', main, d.querySelector('.s-cart-drawer__subtotal')),
              box('cam-note--final', main, d.querySelector('.s-cart-drawer__actions')));
      };
      runD(); watch(d, runD);
    }
  });
  /* 5. Swatch colour fix: Nu Green = #84BCA0 (mint, not olive). Re-applied whenever theme scripts repaint swatches. */
  var HEX_FIX = { 'nu green': '#84BCA0' };
  function norm(n) { return String(n || '').toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function fixSwatch(el) {
    var hex = HEX_FIX[norm(el.getAttribute('data-color-name'))];
    if (hex && el.style.backgroundColor !== 'rgb(132, 188, 160)') { el.style.backgroundImage = ''; el.style.backgroundColor = hex; }
  }
  function fixAll(root) { [].forEach.call((root || document).querySelectorAll('[data-color-name]'), fixSwatch); }
  ready(function () {
    fixAll();
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'attributes') { if (m.target.hasAttribute && m.target.hasAttribute('data-color-name')) fixSwatch(m.target); }
        else [].forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1) { if (n.hasAttribute('data-color-name')) fixSwatch(n); fixAll(n); } });
      });
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'data-color-name'] });
  });
})();

/* 6. Cookie banner: same look and words as apuniforms.com (black card, "Your privacy",
      Choose / Reject all / Accept all). Shopify draws the banner; we only relabel its own
      buttons, so consent is still recorded by Shopify. Styles: ca-mirror.css. */
(function () {
  var FR = /^fr/i.test(document.documentElement.lang || '');
  var T = FR ? {
    title: 'Votre vie privée',
    body: 'Nous et nos partenaires, dont Shopify, utilisons des témoins pour faire fonctionner la boutique, personnaliser votre visite, comprendre l’utilisation du site et vous montrer des publicités pertinentes d’AP Uniforms sur Facebook et Instagram. Rien d’optionnel n’est activé avant votre choix.',
    policy: 'Politique de confidentialité', accept: 'Tout accepter', reject: 'Tout refuser', manage: 'Choisir'
  } : {
    title: 'Your privacy',
    body: 'We and our partners, including Shopify, use cookies to run the store, personalize your visit, see how the site is used and show you relevant AP Uniforms ads on Facebook and Instagram. Nothing optional is turned on until you choose.',
    policy: 'Privacy Policy', accept: 'Accept all', reject: 'Reject all', manage: 'Choose'
  };
  function skin(b) {
    if (!b || b.getAttribute('data-ap-skin')) return;
    var h = b.querySelector('#shopify-pc__banner__body-title'); if (h) h.textContent = T.title;
    var p = b.querySelector('.shopify-pc__banner__body p');
    var a = b.querySelector('#shopify-pc__banner__body-policy-link');
    if (p) { p.textContent = T.body + ' '; if (a) { a.textContent = T.policy; p.appendChild(a); } }
    var acc = b.querySelector('#shopify-pc__banner__btn-accept'); if (acc) acc.textContent = T.accept;
    var dec = b.querySelector('#shopify-pc__banner__btn-decline'); if (dec) dec.textContent = T.reject;
    var man = b.querySelector('#shopify-pc__banner__btn-manage-prefs'); if (man) man.textContent = T.manage;
    b.setAttribute('data-ap-skin', '1');
  }
  function find() { skin(document.getElementById('shopify-pc__banner')); }
  find();
  new MutationObserver(find).observe(document.documentElement, { childList: true, subtree: true });
})();
